import * as React from 'react';
import { UIHeading4, UIHeading5, UIText2, Image } from '@cian/ui-kit';

import * as styles from './recommendationCard.css';
import { IBuilder } from '../../../types/newbuildingRecommendations';

interface ICardProps {
  name: string;
  mediaUrl: string;
  minPrice: string;
  status: string;
  geo?: string | null;
  reviews: React.ReactElement | null;
  url: string;
  builder: IBuilder | null;
  onClick(): void;
}

export const RecommendationCard = ({
  name,
  mediaUrl,
  minPrice,
  status,
  reviews,
  geo,
  url,
  builder,
  onClick,
}: ICardProps) => {
  return (
    <li className={styles['slide']}>
      <a
        data-testid="NewbuildingRecommendationCard"
        data-name="NewbuildingRecommendationCard"
        href={url}
        target="_blank"
        className={styles['card']}
        onClick={onClick}
        rel="noreferrer"
      >
        {builder && (
          <div className={styles['logo']}>
            <Image
              src={builder.logoUrl}
              height="100%"
              width="100%"
              data-testid="RecommendationCardLogo"
              objectFit="contain"
            />
          </div>
        )}
        <img className={styles['image']} src={mediaUrl} alt={name} />
        <div className={styles['content']}>
          <div className={styles['title']}>
            <UIHeading4 whiteSpace="nowrap">{name}</UIHeading4>
          </div>
          {!!minPrice && <UIHeading5>{minPrice}</UIHeading5>}
          <div className={styles['details']}>
            {reviews && <div className={styles['reviews']}>{reviews}</div>}
            <div className={styles['status']}>{status}</div>
          </div>

          {geo && (
            <div className={styles['geo']}>
              <UIText2 display="inline" color="text-secondary-default">
                {geo}
              </UIText2>
            </div>
          )}
        </div>
      </a>
    </li>
  );
};
